<template>
	<!-- <app-banner></app-banner> -->
	<router-view v-slot="{ Component, route }">
		<transition name="fade" mode="out-in">
			<component :is="Component" :key="route.path" />
		</transition>
	</router-view>
</template>
<script setup>
import AppBanner from '@/components/app-banner.vue';
import { onMounted } from 'vue';
onMounted(() => {
	creatShare();
});
const creatShare = () => {
	window.changeShare({
		title: '点击此处>> 探寻你的生肖专属好运地',
		text: '冬至奇遇！12 生肖，别样好运地大揭秘！',
		umKey: '1',
		// showSave: true,  // 缩略图分享，默认为false，可不传
		// showPoster: true, // 卡片&缩略图分享，默认为false，可不传，showSave 和 showPoster 不可同时为true, 可同时不传，均不传时，默认为卡片分享
		// centerImgUrl: img,  //缩略图图片URL，默认为空，可不传，当 showSave 或 showPoster为true时，此参数必传
	});
};
</script>

<style>
.fade-enter-active {
	transition: all 0.6s ease-out;
}

.fade-leave-active {
	transition: all 0.6s ease-out;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
</style>
